export const setInvestWalkthroughStatus = (status, isInOnboarding) => ({
    type: 'SET_INVEST_WALKTHROUGH_STATUS',
    payload: {
        status,
        isInOnboarding,
    },
});
export const setInvestWalkthroughStep = (payload) => ({
    type: 'SET_INVEST_WALKTHROUGH_STEP',
    payload,
});
export const setInvestPortfolioInfo = (payload) => ({
    type: 'SET_INVEST_PORTFOLIO_INFO',
    payload,
});
export const setShowNotificationsWalkThrough = (showNotificationsWalkThrough) => ({
    type: 'SET_SHOW_NOTIFICATIONS_WALKTHROUGH',
    payload: showNotificationsWalkThrough,
});
export const setHasSeenNotificationsWalkThrough = (hasSeenNotificationsWalkThrough) => ({
    type: 'SET_HAS_SEEN_NOTIFICATIONS_WALKTHROUGH',
    payload: hasSeenNotificationsWalkThrough,
});
